
export default {
  name: 'BbTextarea',
  props: {
    label: String,
    hint: String,
    isClearable: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: 'Text',
    },
    hasError: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: Array,
      default: () => [],
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    rows: {
      type: [Number, String],
      default: 5,
    },
    rowHeight: {
      type: [Number, String],
      default: 24,
    },
    autoGrow: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    showClearIcon() {
      return this.isClearable && this.text.length > 0;
    },
    text: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    clearInput() {
      this.text = '';
    },
  },
};
